"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Authorization = void 0;
var react_1 = __importDefault(require("react"));
var Authorization_module_scss_1 = __importDefault(require("./Authorization.module.scss"));
var icons_1 = require("@ant-design/icons");
var adminSlice_1 = require("../../redux/slice/adminSlice");
var selectors_1 = require("../../redux/selectors");
var react_redux_1 = require("react-redux");
var messageContext_1 = require("../../hoc/messageContext");
var react_router_dom_1 = require("react-router-dom");
var typography_1 = __importDefault(require("antd/es/typography"));
var form_1 = __importDefault(require("antd/es/form"));
var input_1 = __importDefault(require("antd/es/input"));
var button_1 = __importDefault(require("antd/es/button"));
var Title = typography_1.default.Title;
var Authorization = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var isAuth = (0, react_redux_1.useSelector)(selectors_1.adminSelector).isAuth;
    var _a = (0, messageContext_1.useMessageContext)(), showError = _a.showError, showSuccess = _a.showSuccess;
    var onFinish = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var username, password;
        return __generator(this, function (_a) {
            username = values.username, password = values.password;
            if (username === 'admin@gmail.com' && password === '123456') {
                sessionStorage.setItem('isAuth', 'true');
                dispatch((0, adminSlice_1.setAuth)(true));
                navigate('/admin/cars');
                showSuccess('Вход выполнен успешно');
            }
            else {
                showError('Неверный логин или пароль');
            }
            return [2 /*return*/];
        });
    }); };
    if (isAuth || sessionStorage.getItem('isAuth')) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    return (react_1.default.createElement("div", { className: Authorization_module_scss_1.default.authorization },
        react_1.default.createElement("div", { className: Authorization_module_scss_1.default.authorization__inner },
            react_1.default.createElement(Title, { level: 1 }, "\u0412\u0445\u043E\u0434 \u0432 \u043F\u0430\u043D\u0435\u043B\u044C \u0443\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F"),
            react_1.default.createElement(form_1.default, { name: "login", initialValues: { remember: true }, style: { maxWidth: 360 }, onFinish: onFinish },
                react_1.default.createElement(form_1.default.Item, { name: "username", rules: [{ required: true, message: 'Пожалуйста, введите логин!' }] },
                    react_1.default.createElement(input_1.default, { prefix: react_1.default.createElement(icons_1.UserOutlined, null), placeholder: "\u041B\u043E\u0433\u0438\u043D" })),
                react_1.default.createElement(form_1.default.Item, { name: "password", rules: [{ required: true, message: 'Пожалуйста, введите пароль!' }] },
                    react_1.default.createElement(input_1.default, { prefix: react_1.default.createElement(icons_1.LockOutlined, null), type: "password", placeholder: "\u041F\u0430\u0440\u043E\u043B\u044C" })),
                react_1.default.createElement(form_1.default.Item, null,
                    react_1.default.createElement(button_1.default, { block: true, type: "primary", htmlType: "submit" }, "\u0412\u043E\u0439\u0442\u0438"))))));
};
exports.Authorization = Authorization;
